import { FuelingProcess } from "../../state";
import {
  HIDE_FUELING_PROCESS_RECEIPT_EDIT,
  SAVE_FUELING_PROCESS_RECEIPT,
  SAVE_FUELING_PROCESS_RECEIPT_FAILED,
  SHOW_FUELING_PROCESS_RECEIPT_EDIT,
} from "./constants";

export interface ShowFuelingProcessReceiptEditAction {
  type: typeof SHOW_FUELING_PROCESS_RECEIPT_EDIT;
  fuelingProcess: FuelingProcess;
}

export function showFuelingProcessReceiptEdit(
  fuelingProcess: FuelingProcess
): ShowFuelingProcessReceiptEditAction {
  return {
    type: SHOW_FUELING_PROCESS_RECEIPT_EDIT,
    fuelingProcess: fuelingProcess,
  };
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function hideFuelingProcessReceiptEdit() {
  return {
    type: HIDE_FUELING_PROCESS_RECEIPT_EDIT,
  };
}

export interface SaveFuelingProcessReceiptAction {
  type: typeof SAVE_FUELING_PROCESS_RECEIPT;
  fuelingProcessId: string;
  totalAmount: number;
  price: number;
  quantity: number;
  currency: string;
}

export function saveFuelingProcessReceipt(
  fuelingProcessId: string,
  totalAmount: number,
  price: number,
  quantity: number,
  currency: string
): SaveFuelingProcessReceiptAction {
  return {
    type: SAVE_FUELING_PROCESS_RECEIPT,
    fuelingProcessId: fuelingProcessId,
    totalAmount: totalAmount,
    price: price,
    quantity: quantity,
    currency: currency,
  };
}

export interface SaveFuelingProcessReceiptFailedAction {
  type: typeof SAVE_FUELING_PROCESS_RECEIPT_FAILED;
  errorCode: string;
  errorMessage: string;
}

export function saveFuelingProcessReceiptFailed(
  errorCode: string,
  errorMessage: string
): SaveFuelingProcessReceiptFailedAction {
  return {
    type: SAVE_FUELING_PROCESS_RECEIPT_FAILED,
    errorCode: errorCode,
    errorMessage: errorMessage,
  };
}
